import axios from "axios";
import { useQuery } from "react-query";
import { config } from "../../utils/conf";
import { requestHeaders } from "../../utils/http";
import useSession from "../Auth/useSession";

export default function useGetNotificationRecipients() {
  const { accessToken, customerId } = useSession();
  const url = `${config.customerProfileApiUrl}/v1/customers/${customerId}/preferences`;

  return useQuery(
    ["notification-recipients", customerId],
    async () => {
      const response = await axios.get(url, {
        headers: requestHeaders(accessToken),
      });
      return response?.data?.notificationRecipients || [];
    },
    {
      enabled: !!customerId,
    },
  );
}
